import { associations, Relation } from "@nozbe/watermelondb";
import { field, json, relation, text } from "@nozbe/watermelondb/decorators";
import {
  ConfigurableOperation,
  PaymentMethodConfiguration,
} from "@towersystems/roam-common/lib/generated-types";
import { noopSanitizeJSON } from "../utils";
import { BaseModel } from "./Base";
import PayType from "./PayType";

export const SanitizeJSONLocationPricing = (json: any) => {
  return json;
};

export default class PaymentMethod extends BaseModel {
  static table = "payment_methods";

  static associations = associations([
    "pay_types",
    { type: "belongs_to", key: "paytype_id" },
  ]);

  @relation("pay_types", "paytype_id") payType: Relation<PayType>;
  @text("retailer_pay_code") retailerPayCode: string | null;
  @text("retailer_pay_type_id") retailerPayTypeId: string | null;
  @text("name") name: string;
  @json("configuration", noopSanitizeJSON)
  configuration: PaymentMethodConfiguration | null;
  @field("enabled") enabled: boolean;
  @json("handler", noopSanitizeJSON) handler: ConfigurableOperation | null;
}
